export default __webpack_public_path__ + "static/media/romanBlindKit.d6534c0c.jpg";